import type {NavigateOptions, To} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';

/** `useNavigate` without the numeric history-step overload; Back goes through `useBackNavigation`. */
export type AppNavigate = (to: To, options?: NavigateOptions) => void;

export const useAppNavigate = (): AppNavigate => useNavigate();
